import { HYPER_STORE_TYPE } from 'components/waste-management/constants'
import { DailyReportResponseItem } from 'components/waste-management/interfaces'
import { getUserName, getUserTitle } from 'utils/authService'
import * as Yup from 'yup'

export const getInitialValues = (
  editItem: DailyReportResponseItem,
  storeType: string,
  jobTitles: AutocompleteOption[],
  companies: Array<{
    id?: number
    wasteCompanyName?: string
    name: string
    grossWeightMeti: number
  }> = []
) => {
  const userTitle = jobTitles?.find(jobTitle => jobTitle.value === getUserTitle())

  return {
    assignee1Name: editItem ? editItem.assignees[0].name : getUserName() ?? '',
    assignee1Function: editItem
      ? { label: editItem.assignees[0].jobTitle, value: editItem.assignees[0].jobTitle }
      : userTitle ?? { label: '', value: '' },
    assignee2Name: editItem ? editItem.assignees[1].name : '',
    assignee2Function: editItem
      ? { label: editItem.assignees[1].jobTitle, value: editItem.assignees[1].jobTitle }
      : { label: '', value: '' },
    ...(storeType === HYPER_STORE_TYPE
      ? {
          assignee3Name: editItem ? editItem.assignees[2].name : '',
          assignee3Function: editItem
            ? { label: editItem.assignees[2].jobTitle, value: editItem.assignees[2].jobTitle }
            : { label: '', value: '' }
        }
      : {}),
    wasteCompanyList: editItem
      ? editItem?.wasteCategoryDailyReports?.map(report => ({
          wasteCompanyName: report.wasteCompanyName,
          name: report.wasteCompanyName,
          grossWeightMeti: report.wasteCategoryCalculatedWeight,
          actualWeight: `${report.wasteCompanyMeasuredWeight ?? ''}`
        })) ?? []
      : companies.map(company => ({
          id: company.id,
          wasteCompanyName: company.wasteCompanyName,
          name: company.name,
          grossWeightMeti: company.grossWeightMeti,
          actualWeight: company.grossWeightMeti ? '' : '0'
        }))
  }
}

export const getValidationSchema = storeType =>
  Yup.object({
    assignee1Name: Yup.string().required('Acest camp este obligatoriu.'),
    assignee1Function: Yup.object().shape({
      label: Yup.string().required('Acest camp este obligatoriu.'),
      value: Yup.string().required('Acest camp este obligatoriu.')
    }),
    assignee2Name: Yup.string().required('Acest camp este obligatoriu.'),
    assignee2Function: Yup.object().shape({
      label: Yup.string().required('Acest camp este obligatoriu.'),
      value: Yup.string().required('Acest camp este obligatoriu.')
    }),
    assignee3Name:
      storeType === HYPER_STORE_TYPE
        ? Yup.string().required('Acest camp este obligatoriu.')
        : Yup.string().nullable(),
    assignee3Function:
      storeType === HYPER_STORE_TYPE
        ? Yup.object().shape({
            label: Yup.string().required('Acest camp este obligatoriu.'),
            value: Yup.string().required('Acest camp este obligatoriu.')
          })
        : Yup.object().nullable(),
    wasteCompanyList: Yup.array().of(
      Yup.object().shape({
        id: Yup.number(),
        wasteCompanyName: Yup.string(),
        name: Yup.string().required(),
        grossWeightMeti: Yup.number().required(),
        actualWeight: Yup.string().required('Acest camp este obligatoriu.')
      })
    )
  })
